import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

import { RegexApp } from "./RegexApp";

ReactDOM.createRoot(document.getElementById('root')).render(
	<React.StrictMode>
		<RegexApp />
	</React.StrictMode>
);
